var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{class:_vm.navToolbarScheme,attrs:{"fixed":_vm.fixedToolbar,"clipped-left":_vm.toolbarClippedLeft,"app":""}},[_c('img',{attrs:{"src":"/static/SecurytyNewLogo.png","height":"60"}})])}
var staticRenderFns = []

export { render, staticRenderFns }